// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"25080036d793619799ae","453":"22b5a6d626569cd6aaab"}[chunkId] + ".js";
};